import * as XLSX from "xlsx";

function generateExcel(data, filename = "data") {
  if (!Array.isArray(data) || data.length === 0) {
    throw new Error("Invalid or empty data provided.");
  }

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(data);

  const range = XLSX.utils.decode_range(worksheet["!ref"]);

  // ✅ Safe styling: clone cells before setting styles
  for (let row = range.s.r; row <= range.e.r; row++) {
    for (let col = range.s.c; col <= range.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
      const cell = worksheet[cellAddress];
      if (cell) {
        worksheet[cellAddress] = {
          ...cell,
          s: { alignment: { wrapText: false } },
        };
      }
    }
  }

  // ✅ Set dynamic column widths
  const columnWidths = [];
  for (let col = range.s.c; col <= range.e.c; col++) {
    let maxLength = 0;
    for (let row = range.s.r; row <= range.e.r; row++) {
      const cell = worksheet[XLSX.utils.encode_cell({ r: row, c: col })];
      if (cell && cell.v) {
        maxLength = Math.max(maxLength, cell.v.toString().length);
      }
    }
    columnWidths.push({ wpx: maxLength * 10 });
  }

  worksheet["!cols"] = columnWidths;

  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  XLSX.writeFile(workbook, `${filename}.xlsx`);
}

export default generateExcel;

export function generatePerformanceReport(monthlyData, dateFrom, dateTo, users = []) {
  const userIdMap = {}
  users.forEach(u => { userIdMap[u.name] = u.id })

  const rows = [
    ['Performance Report'],
    [`Date Range: ${dateFrom} to ${dateTo}`],
    [],
    ['ID', 'User', 'Service', 'Inserted', 'Inserted %', 'Reviewed', 'Reviewed %']
  ]

  Object.entries(monthlyData).forEach(([userName, userServices]) => {
    const userId = userIdMap[userName] || ''
    Object.entries(userServices).forEach(([serviceName, stats]) => {
      if (serviceName === 'overall') return
      const inserted = stats.inserted || 0
      const reviewed = stats.reviewed || 0
      if (inserted === 0 && reviewed === 0) return
      rows.push([
        userId, userName, serviceName,
        inserted, parseFloat((stats.inserted_pct || 0).toFixed(2)),
        reviewed, parseFloat((stats.reviewed_pct || 0).toFixed(2))
      ])
    })

    if (userServices.overall) {
      const { inserted = 0, inserted_pct = 0, reviewed = 0, reviewed_pct = 0 } = userServices.overall
      if (inserted > 0 || reviewed > 0) {
        rows.push([
          userId, userName, 'OVERALL',
          inserted, parseFloat(inserted_pct.toFixed(2)),
          reviewed, parseFloat(reviewed_pct.toFixed(2))
        ])
        rows.push([])
      }
    }
  })

  const wb = XLSX.utils.book_new()
  const ws = XLSX.utils.aoa_to_sheet(rows)
  ws['!cols'] = [{ wch: 10 }, { wch: 25 }, { wch: 20 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }]
  XLSX.utils.book_append_sheet(wb, ws, 'Performance Data')
  XLSX.writeFile(wb, `performance_report_${dateFrom}_${dateTo}.xlsx`)
}
